export default __webpack_public_path__ + "static/media/eye_icon.c2fa09df.svg";